import type { BlockOptionDefinition } from '../../node_modules/@blokkli/editor/dist/runtime/types/blokkOptions.ts'

type GlobalOptionsDefaults = {
  type: BlockOptionDefinition['type']
  default: any
}

export const bundlesWithVisibleLanguage: string[] = []
export const bundlesWithHiddenGlobally: string[] = []

export const globalOptionsDefaults: Record<string, GlobalOptionsDefaults> = {
  "bkVisibleLanguages": {
    "default": [],
    "type": "checkboxes"
  },
  "bkHiddenGlobally": {
    "default": false,
    "type": "checkbox"
  },
  "marginTop": {
    "default": "normal",
    "type": "radios"
  },
  "isHidden": {
    "default": false,
    "type": "checkbox"
  },
  "teaserColor": {
    "default": "BLUE",
    "type": "radios"
  },
  "anchorId": {
    "default": "",
    "type": "text"
  }
} as const